export default class EventLogHelper {

     findIcon(valueName) {

        let ret = ""

        switch(valueName) {
            case "EDITED_BY_USER":
                ret = 'edit';
                break;
            case "PROCESS_FINISHED":
                ret = 'check';
                break;
            case "USER_SET_TO_ROLE":
                ret = 'person_add';
                break;
            case "USER_REMOVED_FROM_ROLE":
                ret = 'person_remove';
                break;
            case "USER_SENT_ROLE_INVITATION":
                ret = 'forward_to_inbox';
                break;
            case "USER_ACCEPTED_ROLE":
                ret = 'how_to_reg';
                break;
            case "USER_REJECTED_ROLE":
                ret = 'cancel';
                break;
            case "FOLLOW_UP_STARTED":
                ret = 'follow_the_signs';
                break;
            case "TECHNICAL_DOCUMENTATION_UPLOAD":
                ret = 'build';
                break;
            case "FACILITY_STATE_UPLOAD":
                ret = 'insights';
                break;
            case "PROCESS_FAILED":
                ret = 'close';
                break;
            case "DOCUMENTATION_UPLOADED_TO_FACILITY":
                ret = 'cloud_upload';
                break;
            case "PROCESS_STEP_FAILED_WITH_IMAGE":
                ret = 'photo_camera';
                break;
            case "POA_GENERATED":
                ret = "loop";
                break;
            case "POA_RECEIVED_TO_FACILITY":
                ret = "gesture";
                break;
            case "REPORT_GENERATED":
                ret = "loop";
                break;
            case "REPORT_RECEIVED_TO_FACILITY":
                ret = "gesture";
                break;
            case "MANUALLY_GENERATED_REPORT":
                ret = "loop";
                break;
            case "GBU_INSPECTION_DONE":
                ret = "report_problem";
                break;
            case "GBU_REPORT_GENERATED":
                ret = "feed";
                break;
            case "GBU_COST_ESTIMATE_GENERATED":
                ret = "euro"
                break;
            case "ONBOARDING_DONE":
                ret = "assignment";
                break;

            default:
                ret = 'do_not_disturb';
                break;
        }

        return ret;
    }



    constructor() {
    }
}
